import React from 'react';
import { useSelector } from 'react-redux';

import {
  roomParticipantsListName,
  eventParticipantsListName,
} from '../../constants';

import ListContainer from './ListContainer';

function Index({ listName }) {
  const participantsList = useSelector((state) => state.participantList);
  const movingBox = useSelector((state) => state.movingBox);

  const renderComp = (list, boxName) => {
    return <ListContainer list={list} boxName={boxName} />;
  };

  const renderFunc = (listName) => {
    switch (listName) {
      case roomParticipantsListName:
        return renderComp(
          participantsList.roomParticipants,
          movingBox.currBoxName
        );

      case eventParticipantsListName:
        return renderComp(
          participantsList.globalParticipants
          // movingBox.currBoxName
        );

      default:
        return renderComp([]);
    }
  };

  return renderFunc(listName);
}

export default Index;
